import React, { Component } from 'react'
import FormScheme, { ClassType } from "../core/FormScheme";
import Col from "antd/lib/col";

export default class FormItemComponent extends Component<{
    class: ClassType,
    [key: string]: any
}> {
    render() {
        const TagName: any = this.props.class.componentObject
        return (
            <Col span={this.props.span || 6}>
                <TagName form={this.props.form} field={this.props.field} formLayout={this.props.formLayout} {...this.props}></TagName>
            </Col>
        )
    }
}
